export default __webpack_public_path__ + "static/media/view2_year_country.dfa02c9a.csv";